module.exports = __webpack_public_path__ + "img/thumbnail_Condorcet_neg.c33101cd.c33101cd.png";